module.exports = __webpack_public_path__ + "images/emoji/meat_on_bone.6f48d0bafa77da517f8d.png";